<template>
  <div class="saving-screen fixed" v-if="isLoading">
    <span>Sayfa hazırlanıyor, lütfen bekleyin....</span>
  </div>
  <div class="saving-screen fixed" v-if="isCreating">
    <span>PDFler hazırlanıyor, lütfen bekleyin....</span>
  </div>
  <r-flex class="r-mb-16 page-header-C">
    <h3>Referans Düzenle</h3>
    <r-flex
      flx="auto"
      align="flex-end"
      style="flex-wrap: nowrap; gap: 8px; min-width: 0;"
      v-if="loaded"
    >
      <!-- Zorluk Seviyesi -->
      <r-select
        v-model="selectedDifficultyLevel"
        label="Zorluk Seviyesi"
        :data="difficultyOptions"
        txt="description"
        val="id"
        width="160px"
        @change="onDifficultyLevelChange"
        :disabled="isLoading"
        class="difficulty-select-C"
      />
      <!-- Branş -->
      <r-select
        v-model="selectedBranchId"
        label="Branş"
        :data="branchOptions"
        txt="title"
        val="id"
        width="160px"
        @change="onBranchChange"
        :disabled="isLoading"
        style="color: rgb(17, 17, 17)"
      />
      <!-- Alt Kategori -->
      <r-select
        v-model="selectedSubCategoryId"
        label="Alt Kategori"
        :data="subCategoryOptions"
        txt="title"
        val="id"
        width="160px"
        @change="onSubCategoryChange"
        :disabled="isLoading || !selectedBranchId"
        style="color: rgb(17, 17, 17)"
      />
      <!-- Bölüm 1 kaydı artık select onChange ile otomatik yapılıyor -->
      <!--
      <r-btn
        bgcolor="#228844"
        @click="saveSection1"
        :disabled="isLoading || !selectedBranchId"
      >
        Kaydet
      </r-btn>
      -->
      <r-btn
        bgcolor="#4422aa"
        @click="goQuestion(-1)"
        v-if="question.data.examNumber !== 1"
        :disabled="isLoading"
      >
        Önceki Soru
      </r-btn>
      <r-btn
        bgcolor="#4422aa"
        @click="goQuestion(1)"
        v-if="question.data.examNumber !== maxQuest"
        :disabled="isLoading"
      >
        Sonraki Soru
      </r-btn>
      <r-btn
        bgcolor="#ffaa11"
        @click="router.push('/referanslar/liste')"
        :disabled="isLoading"
      >
        Referans Listesine Dön
      </r-btn>
      <r-btn
        bgcolor="#aa6600"
        @click="createPDF"
        v-if="store.state.supers.indexOf(store.state.userrole) >= 0"
        :disabled="isLoading"
      >
        PDF Oluştur
      </r-btn>
    </r-flex>
  </r-flex>
  <r-flex
    align="center"
    class="cat-warning-C"
    v-if="loaded && store.state.usertype === 2"
  >
    Şu an
    <h3>&nbsp;{{ question.data.categoryName }}&nbsp;</h3>
    Sınav sorusuna referans ekliyorsunuz.
  </r-flex>
  <!-- Bölüm 2: Sadece Bölüm 1 kuralları sağlanınca görünür -->
  <r-flex :class="['referans-edit-main', canFixed ? 'fixed-content' : '']">
    <r-flex
      flx="5"
      v-show="isSection2Allowed"
      :class="['ref-col-left', canFixed ? 'fixed-col-left' : '']"
    >
      <div class="action-buttons-2x2">
        <div class="action-btn-cell">
          <r-btn bgcolor="#aa6600" @click="AddReference" size="large">
            Referans Ekle
          </r-btn>
        </div>
        <div class="action-btn-cell">
          <r-btn
            bgcolor="#15880d"
            @click="openVideoReferenceModal"
            size="large"
            :disabled="isLoading"
          >
            Video Referans Ekle
          </r-btn>
        </div>
        <div class="action-btn-cell">
          <r-btn
            bgcolor="#0066aa"
            @click="openOriginalQuestionModal"
            size="large"
            :disabled="
              isLoading || !question || !question.data || !question.data.id
            "
          >
            Özgün Soru
          </r-btn>
        </div>
        <div class="action-btn-cell">
          <r-btn
            bgcolor="#664400"
            @click="openSoruKokuModal"
            size="large"
            :disabled="
              isLoading || !question || !question.data || !question.data.id
            "
          >
            Soru Kökü
          </r-btn>
        </div>
      </div>

      <r-flex
        :class="['references-list-C', canFixed ? 'fixed-references' : '']"
      >
        <r-data-list
          :headdata="headdata"
          :listdata="newDataList"
          :disabledrag="store.state.supers.indexOf(store.state.userrole) < 0"
          :opt="outeropt"
          v-if="listloaded"
        >
          <template v-slot:row="{ data, id }">
            <r-data-list
              :headdata="teacherdata"
              :listdata="data.data1"
              :disabledrag="
                store.state.supers.indexOf(store.state.userrole) < 0
              "
              :intitle="data.title"
              :opt="teacherListOpt"
              :lid="id"
            >
              <template v-slot:row="{ data, id }">
                <r-data-list
                  :headdata="teacherdata"
                  :listdata="data.data"
                  :disabledrag="
                    store.state.supers.indexOf(store.state.userrole) < 0 &&
                      data.data[0].userId !== store.state.userid
                  "
                  :intitle="
                    v => {
                      return store.state.supers.indexOf(store.state.userrole) >=
                        0 || data.data[0].userId === store.state.userid
                        ? data.title
                        : '';
                    }
                  "
                  :opt="teacherOpt"
                  :customData="data"
                  :lid="id"
                >
                  <template v-slot:col2="{ datarow }">
                    <r-data-list
                      v-if="
                        datarow.pages.length > 0 &&
                          datarow.pages[0].detail.length > 0
                      "
                      :headdata="drawdata"
                      :listdata="imgListData(datarow.pages[0].detail)"
                      :disabledrag="
                        store.state.supers.indexOf(store.state.userrole) < 0 &&
                          datarow.userId !== store.state.userid
                      "
                      :opt="drawOpt"
                      dragkey="referenceId"
                      selectedkey="selected"
                      :selectedstyle="{ backgroundColor: 'aquamarine' }"
                    />
                  </template>
                </r-data-list>
              </template>
            </r-data-list>
          </template>
        </r-data-list>

        <!-- Dinamik Özellikler Component -->
        <div class="dynamic-properties-wrapper-C">
          <dynamic-property-fields
            v-if="question && question.data && question.data.id"
            :question-id="question.data.id"
            :is-loading="isLoading"
          />
        </div>

        <!-- Video Referansları Listesi -->
        <div
          class="video-references-wrapper-C"
          v-if="loaded && question && question.data && question.data.id"
        >
          <video-reference-list
            ref="videoReferenceListRef"
            :question-id="question.data.id"
            :show-add-button="false"
          />
        </div>

        <!-- Organik Soru Bilgileri (özgün soru metinleri, sadece okuma) -->
        <div
          class="organic-question-wrapper-C"
          v-if="loaded && question && question.data"
        >
          <h4 class="section-title-C">Organik Soru Bilgileri (Özgün Soru)</h4>
          <div class="readonly-content-C">
            <div v-if="question.data.myOriginalCase" class="readonly-block">
              <strong>Vaka bilgisi</strong>
              <div class="readonly-html" v-html="question.data.myOriginalCase"></div>
            </div>
            <div v-if="question.data.myOriginalDetail" class="readonly-block">
              <strong>Soru bilgisi</strong>
              <div class="readonly-html" v-html="question.data.myOriginalDetail"></div>
            </div>
            <div
              v-if="originalChoicesFiltered.length"
              class="readonly-block"
            >
              <strong>Şıklar</strong>
              <div
                v-for="(item, i) in originalChoicesFiltered"
                :key="i"
                class="readonly-choice"
              >
                <span class="choice-letter">{{ item.letter }}</span>
                <span class="readonly-html inline" v-html="item.html"></span>
              </div>
            </div>
            <div v-if="question.data.myOriginalAnswer" class="readonly-block">
              <strong>Cevap</strong>
              <span class="readonly-html">{{ question.data.myOriginalAnswer }}</span>
            </div>
            <div v-if="!hasAnyOriginalContent" class="readonly-empty">
              Özgün soru bilgisi girilmemiş.
            </div>
          </div>
        </div>

        <!-- Soru Kökü bilgisi (sadece okuma) -->
        <div
          class="soru-koku-wrapper-C"
          v-if="loaded && question && question.data"
        >
          <h4 class="section-title-C">Soru Kökü</h4>
          <div class="readonly-content-C">
            <div style="background-color: #e8f4fd; color: #005a9c; padding: 10px; border-radius: 5px; margin-bottom: 12px; font-size: 13px; border: 1px solid #b6d4fe;">
              <strong>Değerli hocamız,</strong><br/>
              Girdiğiniz soru kökü, referans çıktılarında orijinal sorunun yerine kullanılacaktır. Bu ekranda yer alan görsellerde ise, yalnızca hatırlatma amacıyla orijinal soru gösterilmektedir.
            </div>
            <div
              v-if="question.data.detailModifield"
              class="readonly-html"
              v-html="question.data.detailModifield"
            ></div>
            <div v-else class="readonly-empty">Soru kökü bilgisi yok.</div>
          </div>
        </div>
      </r-flex>
    </r-flex>

    <r-flex
      flx="7"
      align="center"
      
      :class="[canFixed ? 'fixed-col-right' : '']"
    >
      <references-pages
        v-if="newDataList.length > 0 && pagesloaded"
        :pagedata="newDataList"
        :qtype="questionType"
        :question="question.data"
        :imagelist="imagesList"
        @savenote="saveNote"
        @selectimage="selectImage"
        v-model:updated="pageUpdated"
      />
      <references-temp-page
        v-if="newDataList.length === 0 && loaded"
        :qtype="questionType"
        :question="question.data"
      />
    </r-flex>
  </r-flex>

  <r-panel
    v-if="imgPanel"
    v-model:isactive="imgPanel"
    pos="center"
    closepos="out-right"
    classes="r-referans-image-panel-C r-flx-dw-80"
    classcontent="r-flx-nop"
    width="50%"
  >
    <template v-slot:title>
      <r-flex class="r-flx-nop">
        <r-flex flx="4">
          <r-select
            label="Kitap"
            :data="distinctNotes"
            txt="name"
            val="id"
            v-model="sdersnot"
            @change="dersNoteChange"
          />
        </r-flex>
        <r-flex flx="3">
          <r-select
            :disabled="sdersnot ? false : true"
            label="Kitap"
            :data="fasikulCount"
            v-model="selectedFassicule"
            @change="fassiculeChange"
          />
        </r-flex>
        <r-flex flx="3" v-if="selectedFassicule !== null">
          <r-select
            :disabled="sdersnot ? false : true"
            :label="'Kitap Sayfaları'"
            :data="fasikulPages['p' + selectedFassicule]"
            txt="p"
            val="p"
            v-model="selectedPage"
            @change="pageSelected"
          />
        </r-flex>
        <r-flex flx="1">
          <r-btn @click="previewPage()">Önceki</r-btn>
        </r-flex>
        <r-flex flx="1">
          <r-btn @click="lastPage()">Sonraki</r-btn>
        </r-flex>
      </r-flex>
    </template>
    <referans-image
      v-if="selectedPage !== null"
      :img="imgUrl"
      :data="imgData"
      :work-folder="currentWorkFolder"
      v-model:close="imgPanel"
      v-model:saveme="saveme"
    />
  </r-panel>

  <!-- Özgün Soru Modal -->
  <r-panel
    v-if="question && question.data && question.data.id"
    v-model:isactive="showOriginalModal"
    title="Özgün Soru"
    classes="r-flx-dw-80"
    width="60%"
    pos="center"
  >
    <template v-slot:titlebuttons>
      <r-btn
        bgcolor="#15880d"
        @click="saveOriginalQuestion"
        :disabled="isSavingOriginal || isLoading"
      >
        Kaydet
      </r-btn>
    </template>
    <div class="question-original-section">
      <r-flex class="r-mb-16">
        <template v-if="isTeacher">
          <div class="teacher-display-field" style="width: 40%;">
            <label class="teacher-display-label">Özgün Soruyu Ekleyen Hoca</label>
            <div class="teacher-display-value">{{ store.state.username }}</div>
          </div>
        </template>
        <r-select
          v-else
          v-model="originalData.teacherId"
          label="Özgün Soruyu Ekleyen Hoca"
          :data="originalTeacherOptions"
          txt="name"
          val="id"
          width="40%"
        />
      </r-flex>
      <r-flex>
        <r-flex class="r-mb-16"><h4>Özgün Vaka</h4></r-flex>
        <vue-editor
          v-model="originalData.myOriginalCase"
          label="Özgün Vaka"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        />
      </r-flex>
      <r-flex class="r-mt-8">
        <r-flex class="r-mb-16"><h4>Özgün Soru Kökü</h4></r-flex>
        <vue-editor
          v-model="originalData.myOriginalDetail"
          label="Özgün Soru Kökü"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        />
      </r-flex>
      <r-flex class="r-mt-8">
        <r-flex class="r-mb-16"><h4>Özgün Şıklar</h4></r-flex>
        <r-flex flx="12">
          <r-flex class="r-mb-8"><strong>A Şıkkı</strong></r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="originalData.myOriginalA"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />
        </r-flex>
        <r-flex flx="12">
          <r-flex class="r-mb-8"><strong>B Şıkkı</strong></r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="originalData.myOriginalB"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />
        </r-flex>
        <r-flex flx="12">
          <r-flex class="r-mb-8"><strong>C Şıkkı</strong></r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="originalData.myOriginalC"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />
        </r-flex>
        <r-flex flx="12">
          <r-flex class="r-mb-8"><strong>D Şıkkı</strong></r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="originalData.myOriginalD"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />
        </r-flex>
        <r-flex flx="12">
          <r-flex class="r-mb-8"><strong>E Şıkkı</strong></r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="originalData.myOriginalE"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />
        </r-flex>
      </r-flex>
      <r-flex class="r-mt-8">
        <r-select
          v-model="originalData.myOriginalAnswer"
          label="Özgün Cevap Şıkkı"
          :data="originalAnswerOptions"
          txt="txt"
          val="val"
          width="30%"
        />
      </r-flex>
    </div>
  </r-panel>

  <!-- Soru Kökü (DetailModifield) Modal -->
  <r-panel
    v-if="question && question.data && question.data.id"
    v-model:isactive="showSoruKokuModal"
    title="Soru Kökü"
    classes="r-flx-dw-80"
    width="60%"
    pos="center"
  >
    <template v-slot:titlebuttons>
      <r-btn
        bgcolor="#15880d"
        @click="saveSoruKoku"
        :disabled="isSavingSoruKoku || isLoading"
      >
        Kaydet
      </r-btn>
    </template>
    <div class="question-original-section">
      <r-flex class="r-mb-16">
        <h4>Soru kökü ve cevabı</h4>
      </r-flex>
      <r-flex>
        <vue-editor
          v-model="detailModifieldEdit"
          label="Soru Kökü"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        />
      </r-flex>
    </div>
  </r-panel>

  <!-- Video Referans Ekleme Modal -->
  <video-reference-modal
    v-if="question && question.data && question.data.id"
    v-model:isactive="showVideoModal"
    :video-reference="selectedVideoReference"
    :question-id="question.data.id"
    :is-edit-mode="false"
    @saved="handleVideoReferenceSaved"
  />
</template>
<script>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import router from "@/router/";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ReferansImage from "./ReferansImage";
import ReferencesPages from "./ReferencesPages";
import ReferencesTempPage from "./ReferencesTempPage";
import DynamicPropertyFields from "@/components/DynamicPropertyFields";
import VideoReferenceModal from "@/components/VideoReferenceList/VideoReferenceModal.vue";
import VideoReferenceList from "@/components/VideoReferenceList";

export default {
  components: {
    ReferansImage,
    ReferencesPages,
    ReferencesTempPage,
    DynamicPropertyFields,
    VideoReferenceModal,
    VideoReferenceList
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const notesList = ref({});
    const notesCatsList = ref({});
    const distinctNotes = computed(() => {
      const arr = notesList.value?.data;
      if (!Array.isArray(arr)) return [];
      const map = new Map();
      for (const n of arr) {
        const id = n && n.id != null ? n.id : null;
        if (id == null) continue;
        if (!map.has(id)) map.set(id, n);
      }
      return Array.from(map.values());
    });
    const sdersnot = ref(null);
    const fasikulCount = ref([]);
    const fasikulPages = ref({});
    const selectedFassicule = ref(null);
    const selectedPage = ref(null);
    const imgPanel = ref(false);
    const imgUrl = ref("");
    const imgData = ref({});
    const question = ref({});
    const loaded = ref(false);
    const listloaded = ref(false);
    const pagesloaded = ref(false);
    const pageUpdated = ref(false);
    const isLoading = ref(false);
    const saveData = ref({});
    const refDatas = ref({});
    const saveme = ref(false);
    const canFixed = ref(false);
    const dataList = ref([]);
    const imagesList = ref([]);
    const imageSelectData = ref({});
    const listScrollTop = ref(0);
    const pageScrollTop = ref(0);
    const isCreating = ref(false);
    const questionCount = ref(0);
    const difficultyLevels = ref([]);
    const selectedDifficultyLevel = ref(null);
    const showVideoModal = ref(false);
    const selectedVideoReference = ref(null);
    // Özgün soru düzenleme modalı için state
    const showOriginalModal = ref(false);
    const isSavingOriginal = ref(false);
    const originalData = ref({
      teacherId: null,
      myOriginalCase: "",
      myOriginalDetail: "",
      myOriginalA: "",
      myOriginalB: "",
      myOriginalC: "",
      myOriginalD: "",
      myOriginalE: "",
      myOriginalAnswer: null
    });
    const originalTeacherList = ref({ data: [] });
    // Soru kökü (DetailModifield) modalı
    const showSoruKokuModal = ref(false);
    const detailModifieldEdit = ref("");
    const isSavingSoruKoku = ref(false);
    const branchList = ref({ data: [] });
    const selectedBranchId = ref(null);
    const subCategoryList = ref({ data: [] });
    const selectedSubCategoryId = ref(null);

    // Hoca: usercatid (categoryId) varsa kullanıcı bir branşa atanmış demek
    const isTeacher = computed(() => {
      const catId = store.state.usercatid;
      return catId !== null && catId !== undefined && catId !== 0;
    });

    const questionType = computed(() => {
      if (store.state.usertype === 0) {
        if (parseInt(question.value.data.examNumber) <= store.state.tustemelq)
          return "Temel Bilimler";
        else return "Klinik Bilimler";
      } else if (store.state.usertype === 1) {
        if (parseInt(question.value.data.examNumber) <= store.state.dustemelq)
          return "Temel Bilimler";
        else return "Klinik Bilimler";
      } else if (store.state.usertype === 2) {
        return question.value.data.categoryName;
      }
    });
    const maxQuest = computed(() => {
      if (store.state.usertype === 0) return store.state.tustotalq;
      if (store.state.usertype === 1) return store.state.dustotalq;
      if (store.state.usertype === 2) return questionCount.value;
    });
    const currentWorkFolder = computed(() => {
      const year = question.value?.data?.year;
      const month = question.value?.data?.month;
      if (year == null || month == null) return "";
      return `${year}${String(month).padStart(2, "0")}`;
    });
    const getReferenceImageProxyUrl = ({
      workFolder,
      imageRoot,
      categoryId,
      noteId,
      fileName
    }) => {
      const params = new URLSearchParams({
        workFolder: String(workFolder || ""),
        imageRoot: String(imageRoot || ""),
        categoryId: String(categoryId || ""),
        noteId: String(noteId || ""),
        fileName: String(fileName || "")
      });
      // Development modda proxy kullan (CORS için)
      const apiBase = process.env.NODE_ENV === "development" ? "/api/" : store.state.baseurl;
      return `${apiBase}references/getreferenceimage?${params.toString()}`;
    };

    // Bölüm 2: Sadece ekrandaki seçimler gerçekten atanmışsa aktif
    const isSection2Allowed = computed(() => {
      if (!loaded.value || !question.value?.data?.id) return false;

      // Not: RSelect strict eşitlik ile eşleştiriyor (modelValue === item[id]).
      // Bu yüzden string/number mismatch olursa ekranda "Hepsi" görünebilir ama Number() ile >0 geçebilir.
      // Burada hem sayısal doğrulama hem de seçenek listesinde gerçekten var mı kontrolü yapıyoruz.

      const branchId =
        selectedBranchId.value != null ? Number(selectedBranchId.value) : NaN;
      if (!Number.isFinite(branchId) || branchId <= 0) return false;
      const branchExists = (branchList.value?.data || []).some(
        x => Number(x?.id) === branchId
      );
      if (!branchExists) return false;

      const subCategoryId =
        selectedSubCategoryId.value != null
          ? Number(selectedSubCategoryId.value)
          : NaN;
      if (!Number.isFinite(subCategoryId) || subCategoryId <= 0) return false;
      const subExists = (subCategoryList.value?.data || []).some(
        x => Number(x?.id) === subCategoryId
      );
      if (!subExists) return false;

      const isSuper = store.state.supers.indexOf(store.state.userrole) >= 0;
      if (isSuper) {
        const difficultyLevelId =
          selectedDifficultyLevel.value != null
            ? Number(selectedDifficultyLevel.value)
            : NaN;
        if (!Number.isFinite(difficultyLevelId) || difficultyLevelId <= 0)
          return false;
        const diffList = difficultyLevels.value || [];
        const diffExists = diffList.some(x => {
          const id = x?.id ?? x?.Id;
          return Number(id) === difficultyLevelId;
        });
        if (!diffExists) return false;
        // "Belirtilmedi" seçiliyse alt kısım gizli (gerçek zorluk seçilmeli)
        const selectedDiff = diffList.find(x => Number(x?.id ?? x?.Id) === difficultyLevelId);
        const desc = (selectedDiff?.description ?? selectedDiff?.Description ?? "").trim().toLowerCase();
        if (desc === "belirtilmedi") return false;
      }

      return true;
    });

    const originalTeacherOptions = computed(() => {
      const arr =
        originalTeacherList.value &&
        Array.isArray(originalTeacherList.value.data)
          ? originalTeacherList.value.data
          : [];
      return [{ name: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const originalAnswerOptions = computed(() => {
      const choices = store.state.choices || ["A", "B", "C", "D", "E"];
      return [
        { txt: "Seçiniz", val: null },
        ...choices.map(c => ({ txt: c, val: c }))
      ];
    });

    const newDataList = computed(() => {
      return dataList.value;
    });
    // Organik soru bilgileri: şıklar listesi (her zaman 5 eleman A–E)
    const choiceListForDisplay = computed(() => {
      if (!question.value?.data) return [];
      const q = question.value.data;
      const list = q.choiceList;
      if (list && Array.isArray(list) && list.length >= 5)
        return list.slice(0, 5);
      return [
        (list && list[0]) || q.a || "",
        (list && list[1]) || q.b || "",
        (list && list[2]) || q.c || "",
        (list && list[3]) || q.d || "",
        (list && list[4]) || q.e || ""
      ];
    });
    // Özgün soru şıkları (Organik Soru Bilgileri blokunda gösterilir, A–E sıralı)
    const originalChoiceListForDisplay = computed(() => {
      if (!question.value?.data) return [];
      const q = question.value.data;
      return [
        q.myOriginalA != null ? String(q.myOriginalA).trim() : "",
        q.myOriginalB != null ? String(q.myOriginalB).trim() : "",
        q.myOriginalC != null ? String(q.myOriginalC).trim() : "",
        q.myOriginalD != null ? String(q.myOriginalD).trim() : "",
        q.myOriginalE != null ? String(q.myOriginalE).trim() : ""
      ];
    });
    // Özgün şıklardan sadece dolu olanları (harf + içerik) — Organik blokta gösterim için
    const originalChoicesFiltered = computed(() => {
      const list = originalChoiceListForDisplay.value;
      const labels = ["A", "B", "C", "D", "E"];
      return list
        .map((html, i) => ({ letter: labels[i] + ")", html }))
        .filter(x => x.html !== "");
    });
    const hasAnyOriginalContent = computed(() => {
      if (!question.value?.data) return false;
      const q = question.value.data;
      const hasCase = q.myOriginalCase != null && String(q.myOriginalCase).trim() !== "";
      const hasDetail = q.myOriginalDetail != null && String(q.myOriginalDetail).trim() !== "";
      const hasAnswer = q.myOriginalAnswer != null && String(q.myOriginalAnswer).trim() !== "";
      const hasChoice = originalChoiceListForDisplay.value.some(s => s !== "");
      return hasCase || hasDetail || hasAnswer || hasChoice;
    });
    const choiceLabels = ["A", "B", "C", "D", "E"];
    const imgListData = d => {
      var newArr = [];
      d.forEach(dat => {
        if (dat.isImg) newArr.push(dat);
      });
      return newArr;
    };
    const newList = () => {
      listloaded.value = false;
      pagesloaded.value = false;
      if (refDatas.value.data.length > 0) isLoading.value = true;
      pageUpdated.value = false;
      var el = document.querySelector(".references-list-C");
      if (canFixed.value) listScrollTop.value = el.scrollTop;
      pageScrollTop.value = window.scrollY;
      setTimeout(() => {
        refDatas.value.data.splice(
          0,
          refDatas.value.data.length,
          ...refDatas.value.data
        );
        refDatas.value.data.sort((a, b) => {
          return a.priority - b.priority;
        });
        imagesList.value = [];
        var newArr = [];
        var newImgs = [];
        var listKeys = [];
        var ind = 0;

        refDatas.value.data.forEach(itm => {
          if (listKeys.indexOf(itm.noteCategoryName) === -1) {
            listKeys.push(itm.noteCategoryName);
            let notcat = notesCatsList.value.data.filter(v => {
              return v.id === itm.noteCategoryId;
            })[0];
            newArr.push({
              id: ind,
              title: itm.noteCategoryName,
              pagetitle: notcat.title,
              pagedesc: notcat.description,
              data: [itm]
            });
            newImgs.push([]);
            ind++;
          } else {
            newArr[listKeys.indexOf(itm.noteCategoryName)].data.push(itm);
          }
        });
        newArr.forEach((itm, i) => {
          var subKeys = [];
          var indi = 0;
          itm.data1 = [];
          itm.data.forEach(dr => {
            if (subKeys.indexOf(dr.userId) === -1) {
              subKeys.push(dr.userId);
              itm.data1.push({
                id: indi,
                title: dr.username,
                userid: dr.userId,
                data: [dr]
              });

              indi++;
            } else {
              itm.data1[subKeys.indexOf(dr.userId)].data.push(dr);
            }
            dr.pid = i;
            delete itm.data;
          });
          itm.data1.forEach((dat, m) => {
            dat.data.forEach((pag, n) => {
              if (pag.pages.length > 0) {
                if (pag.pages[0].detail.length > 0) {
                  pag.pages[0].detail.forEach((drw, o) => {
                    if (drw.isImg) {
                      drw.iid = i;
                      drw.tid = m;
                      drw.pid = n;
                      drw.kid = o;
                      drw.userId = pag.userId;
                      drw.dname =
                        // 'Fasikül ' +
                        // pag.pages[0].fassiculeId +
                        " Sayfa " + drw.pageNo;
                      (drw.url = getReferenceImageProxyUrl({
                        workFolder: currentWorkFolder.value,
                        imageRoot: `edited_ref_img_${store.state.usertype}`,
                        categoryId: question.value.data.categoryId,
                        noteId: pag.lessonNoteId,
                        fileName: `${drw.fileName}.jpg`
                      })),
                        newImgs[i].push(drw);
                    }
                  });
                }
              }
            });
          });
        });
        dataList.value.splice(0, dataList.value.length, ...newArr);
        imagesList.value.splice(0, imagesList.value.length, ...newImgs);
        listloaded.value = true;
        pagesloaded.value = true;
        setTimeout(() => {
          if (isLoading.value) isLoading.value = false;
        }, 1500);
      }, 30);
    };

    const headdata = computed(() => {
      return [
        {
          style: { width: "100%" }
        }
      ];
    });
    const outeropt = {
      datacount: false,
      header: false,
      dragend: v => {
        dragEnded(v);
      },
      class: {
        list: "outer-data-list"
      }
    };
    const teacherdata = computed(() => {
      return [
        {
          style: { width: "40%" },
          key: "lessonNoteName",
          cval: v => {
            return `${v.lessonNoteName} (${v.id})`;
          }
        },
        {
          style: { width: "45%" }
        }
      ];
    });
    const teacherListOpt = {
      datacount: false,
      collapse: true,
      dragend: (v, id) => {
        dragEndedTeacherList(v, id);
      },
      class: {
        list: "teacher-list-data-list"
      }
    };
    const teacherOpt = {
      datacount: false,
      dragend: (v, id) => {
        dragEndedTeacherData(v, id);
      },
      intitle: {
        style: { width: "82%" }
      },
      class: {
        wrapper: "wrapper-data-list"
      },
      buttons: {
        style: { width: "18%" },
        edit: {
          showf: v => {
            return (
              v.userId === store.state.userid ||
              store.state.supers.indexOf(store.state.userrole) >= 0
            );
          },
          type: "out",
          func: d => {
            editFunc(d);
          }
        },
        delete: {
          showf: v => {
            return (
              v.userId === store.state.userid ||
              store.state.supers.indexOf(store.state.userrole) >= 0
            );
          },
          func: d => {
            deleteFunc(d);
          }
        },
        add: {
          show: store.state.supers.indexOf(store.state.userrole) >= 0,
          pos: "head",
          func: d => {
            addFunc(d);
          }
        }
      }
    };
    const drawdata = computed(() => {
      return [
        {
          style: { width: "100%" },
          key: "dname",
          title: "Seçimler"
        }
      ];
    });
    const drawOpt = {
      datacount: false,
      dragend: v => {
        dragEndedDraw(v);
      },
      row: {
        func: v => {
          drwRowClick(v);
        }
      },
      header: false
    };
    const reSetPriority = async () => {
      var priorityList = [];
      var i = 0;
      dataList.value.forEach(itm => {
        itm.data1.forEach(itmnote => {
          itmnote.data.forEach(itmdata => {
            priorityList.push({
              referenceId: itmdata.id,
              Priority: i
            });
            i++;
          });
        });
      });

      await store.dispatch("postDatas", {
        api: "references/prioritizereferences",
        data: priorityList
      });
      imageSelectData.value = {};
      let list = await getReferenceDetail();
      refDatas.value = Object.assign({}, list);
      newList();
    };
    const drwRowClick = v => {
      var el = document.getElementById(
        "imgc-" +
          question.value.data.examNumber +
          "-" +
          v.row.iid +
          "-" +
          v.row.tid +
          "-" +
          v.row.pid +
          "-" +
          v.row.kid
      );
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    };
    const dragEnded = async d => {
      dataList.value.splice(0, dataList.value.length, ...d);
      await reSetPriority();
    };
    const dragEndedTeacherList = async (d, id) => {
      dataList.value[id].data1 = d;
      await reSetPriority();
    };
    const dragEndedTeacherData = async (d, id) => {
      dataList.value[d[0].pid].data1[id].data = d;
      await reSetPriority();
    };
    const dragEndedDraw = async d => {
      dataList.value[d[0].iid].data1[d[0].tid].data[
        d[0].pid
      ].pages[0].detail = d;
      await savePage(dataList.value[d[0].iid].data1[d[0].tid].data[d[0].pid]);
    };
    const addFunc = async d => {
      sdersnot.value = null;
      imgData.value.subcatname = questionType.value;
      imgData.value.noteid = sdersnot.value;
      imgData.value.catname = question.value.data.categoryName;
      imgData.value.catid = question.value.data.categoryId;
      imgData.value.examnumber = question.value.data.examNumber;
      imgData.value.userid = d.userid;
      saveData.value.userId = d.userid;
      saveData.value.id = 0;
      selectedFassicule.value = null;
      selectedPage.value = null;
      imgData.value.detail = [];
      imgUrl.value = "";
      imgPanel.value = true;
    };
    const deleteFunc = async d => {
      if (isCreating.value) return;
      isCreating.value = true;
      try {
        await store.dispatch("postDatas", {
          api: "references/deletereference",
          data: { id: parseInt(d.row.id) }
        });
        refDatas.value = await getReferenceDetail();
        newList();
      } finally {
        isCreating.value = false;
      }
    };
    const getNotesList = async () => {
      var api =
        store.state.supers.indexOf(store.state.userrole) >= 0
          ? "notes/getallnotes"
          : "notes/getnotesforuser";
      var params = {
        isActive: true
      };
      if (store.state.supers.indexOf(store.state.userrole) < 0)
        params.userid = parseInt(store.state.userid);
      let list = await store.dispatch("getDatas", {
        api: api,
        params: params
      });
      return list;
    };
    const getQuestion = async () => {
      let list = await store.dispatch("getDatas", {
        api: "questions/getquestion",
        params: {
          id: route.params.id
        }
      });
      return list;
    };

    const loadOriginalTeacherList = async () => {
      if (
        originalTeacherList.value &&
        Array.isArray(originalTeacherList.value.data) &&
        originalTeacherList.value.data.length > 0
      ) {
        return;
      }
      const teacherRes = await store.dispatch("getDatas", {
        api: "notes/getteacherlist"
      });
      originalTeacherList.value = teacherRes?.data
        ? { data: teacherRes.data }
        : { data: [] };
    };

    const openOriginalQuestionModal = async () => {
      if (!question.value || !question.value.data || !question.value.data.id)
        return;
      await loadOriginalTeacherList();

      const qd = question.value.data;
      // Hoca ise kendi ID'sini otomatik set et, değilse mevcut değeri kullan
      if (isTeacher.value) {
        originalData.value.teacherId = store.state.userid;
      } else {
        originalData.value.teacherId = qd.teacherId ?? null;
      }
      originalData.value.myOriginalCase = qd.myOriginalCase || "";
      originalData.value.myOriginalDetail = qd.myOriginalDetail || "";
      originalData.value.myOriginalA = qd.myOriginalA || "";
      originalData.value.myOriginalB = qd.myOriginalB || "";
      originalData.value.myOriginalC = qd.myOriginalC || "";
      originalData.value.myOriginalD = qd.myOriginalD || "";
      originalData.value.myOriginalE = qd.myOriginalE || "";
      originalData.value.myOriginalAnswer =
        qd.myOriginalAnswer && String(qd.myOriginalAnswer).trim() !== ""
          ? qd.myOriginalAnswer
          : null;

      showOriginalModal.value = true;
    };

    const saveOriginalQuestion = async () => {
      if (isSavingOriginal.value) return;
      if (!question.value || !question.value.data || !question.value.data.id)
        return;
      try {
        isSavingOriginal.value = true;
        const qd = question.value.data;

        const payload = {
          Id: qd.id,
          CategoryId: qd.categoryId,
          SubCategoryId: qd.subCategoryId,
          Number: qd.number,
          UserId: qd.userId,
          ExamNumber: qd.examNumber,
          Month: qd.month,
          Year: qd.year,
          IsCase: qd.isCase,
          Case: qd.case || "",
          Detail: qd.detail || "",
          DetailModifield: qd.detailModifield || "",
          ChoiceList: qd.choiceList || [],
          Answer: qd.answer,
          Description: qd.description || "",
          // Özgün soru alanları
          TeacherId: originalData.value.teacherId || null,
          MyOriginalCase: originalData.value.myOriginalCase || "",
          MyOriginalDetail: originalData.value.myOriginalDetail || "",
          MyOriginalA: originalData.value.myOriginalA || "",
          MyOriginalB: originalData.value.myOriginalB || "",
          MyOriginalC: originalData.value.myOriginalC || "",
          MyOriginalD: originalData.value.myOriginalD || "",
          MyOriginalE: originalData.value.myOriginalE || "",
          MyOriginalAnswer:
            originalData.value.myOriginalAnswer &&
            String(originalData.value.myOriginalAnswer).trim() !== ""
              ? originalData.value.myOriginalAnswer
              : null
        };

        await store.dispatch("postDatas", {
          api: "questions/addquestion",
          data: payload
        });
        // Soruyu tazele
        question.value = await getQuestion();
        showOriginalModal.value = false;
      } finally {
        isSavingOriginal.value = false;
      }
    };

    const openSoruKokuModal = () => {
      if (!question.value || !question.value.data || !question.value.data.id)
        return;
      detailModifieldEdit.value = question.value.data.detailModifield || "";
      showSoruKokuModal.value = true;
    };

    const saveSoruKoku = async () => {
      if (isSavingSoruKoku.value) return;
      if (!question.value || !question.value.data || !question.value.data.id)
        return;
      try {
        isSavingSoruKoku.value = true;
        const qd = question.value.data;
        const payload = {
          Id: qd.id,
          CategoryId: qd.categoryId,
          SubCategoryId: qd.subCategoryId,
          Number: qd.number,
          UserId: qd.userId,
          ExamNumber: qd.examNumber,
          Month: qd.month,
          Year: qd.year,
          IsCase: qd.isCase,
          Case: qd.case || "",
          Detail: qd.detail || "",
          DetailModifield: detailModifieldEdit.value || "",
          ChoiceList: qd.choiceList || [],
          Answer: qd.answer,
          Description: qd.description || "",
          TeacherId: qd.teacherId ?? null,
          MyOriginalCase: qd.myOriginalCase || "",
          MyOriginalDetail: qd.myOriginalDetail || "",
          MyOriginalA: qd.myOriginalA || "",
          MyOriginalB: qd.myOriginalB || "",
          MyOriginalC: qd.myOriginalC || "",
          MyOriginalD: qd.myOriginalD || "",
          MyOriginalE: qd.myOriginalE || "",
          MyOriginalAnswer:
            qd.myOriginalAnswer && String(qd.myOriginalAnswer).trim() !== ""
              ? qd.myOriginalAnswer
              : null
        };
        await store.dispatch("postDatas", {
          api: "questions/addquestion",
          data: payload
        });
        question.value = await getQuestion();
        showSoruKokuModal.value = false;
      } finally {
        isSavingSoruKoku.value = false;
      }
    };
    const getReferenceDetail = async b => {
      var idi = b || route.params.id;
      let list = await store.dispatch("getDatas", {
        api: "references/getreferencesforquestion",
        params: {
          questionid: idi,
          isImg: false
        }
      });
      return list;
    };
    const getNoteCatsList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return list;
    };

    const goQuestion = async i => {
      if (!isLoading.value) {
        var num = parseInt(question.value.data.examNumber) + i;
        let api = "references/getquestionbyexamnumber";
        let params = {
          examnumber: num,
          workmonth: String(question.value.data.month).padStart(2, "0"),
          workyear: String(question.value.data.year)
        };
        if (store.state.usertype === 2) {
          api = "references/getquestionbyexamnumberandcategory";
          params.categoryid = question.value.data.categoryId;
        }
        let list = await store.dispatch("getDatas", {
          api: api,
          params: params
        });

        router.push("/referanslar/duzenle/" + list.data.id);
        question.value = Object.assign({}, list);
        // Zorluk seviyesini güncelle
        if (
          question.value &&
          question.value.data &&
          question.value.data.difficultyLevelId
        ) {
          selectedDifficultyLevel.value =
            question.value.data.difficultyLevelId != null
              ? Number(question.value.data.difficultyLevelId)
              : null;
        } else {
          selectedDifficultyLevel.value = null;
        }
        // Branş ve alt kategori select'lerini güncelle
        if (question.value.data.categoryId) {
          selectedBranchId.value =
            question.value.data.categoryId != null
              ? Number(question.value.data.categoryId)
              : null;
          // Alt kategorileri getir
          const subCatResult = await store.dispatch("getDatas", {
            api: "categories/getsubcategories",
            params: { pid: question.value.data.categoryId }
          });
          if (
            subCatResult &&
            subCatResult.data &&
            Array.isArray(subCatResult.data)
          ) {
            subCategoryList.value = { data: subCatResult.data };
            // Mevcut SubCategoryId'yi seç (0 ise null yap)
            if (
              question.value.data.subCategoryId &&
              question.value.data.subCategoryId !== 0
            ) {
              selectedSubCategoryId.value =
                question.value.data.subCategoryId != null
                  ? Number(question.value.data.subCategoryId)
                  : null;
            } else {
              selectedSubCategoryId.value = null;
            }
          }
        }
        saveData.value.branchId = parseInt(question.value.data.categoryId);
        saveData.value.questionId = parseInt(list.data.id);
        saveData.value.pages = [];
        refDatas.value = await getReferenceDetail(list.data.id);
        newList();
      }
    };
    const getQuestionCount = async () => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getquestioncount",
        params: {
          categoryid: question.value.data.categoryId
        }
      });
      return list.data;
    };
    const getCatList = async (pid = 0) => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: { pid }
      });
      return list;
    };
    const branchOptions = computed(() => {
      const arr =
        branchList.value && Array.isArray(branchList.value.data)
          ? branchList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });
    const subCategoryOptions = computed(() => {
      const arr =
        subCategoryList.value && Array.isArray(subCategoryList.value.data)
          ? subCategoryList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });
    // Zorluk seviyesi: "Belirtilmedi" seçiliyse veya seçili değilse alt kısım gizlenir (isSection2Allowed)
    const difficultyOptions = computed(() => {
      const raw = Array.isArray(difficultyLevels.value) ? difficultyLevels.value : [];
      const desc = d => (d?.description ?? d?.Description ?? "").trim().toLowerCase();
      const arr = raw.filter(x => desc(x) !== "belirtilmedi");
      return [{ description: "Belirtilmedi", id: null }, ...arr];
    });
    const onBranchChange = async e => {
      if (!e || e.id === undefined) return;
      selectedBranchId.value = e.id != null ? Number(e.id) : null;

      // Seçilen branşın alt kategorilerini getir (kaydetme yok, sadece Kaydet'te)
      if (e.id) {
        const result = await store.dispatch("getDatas", {
          api: "categories/getsubcategories",
          params: { pid: e.id }
        });
        if (result && result.data && Array.isArray(result.data)) {
          subCategoryList.value = { data: result.data };
          if (
            question.value?.data?.subCategoryId &&
            question.value.data.subCategoryId !== 0
          ) {
            const exists = result.data.find(
              cat => cat.id === question.value.data.subCategoryId
            );
            selectedSubCategoryId.value = exists
              ? question.value.data.subCategoryId
              : null;
          } else {
            selectedSubCategoryId.value = null;
          }
        } else {
          subCategoryList.value = { data: [] };
          selectedSubCategoryId.value = null;
        }
      } else {
        subCategoryList.value = { data: [] };
        selectedSubCategoryId.value = null;
      }
    };
    const onSubCategoryChange = async e => {
      if (!e) return;
      selectedSubCategoryId.value = e.id != null ? Number(e.id) : null;
      // Alt kategori değişince Bölüm 1'i otomatik kaydet
      if (selectedBranchId.value) {
        await saveSection1();
      }
    };
    // Bölüm 1 Kaydet: branş + alt kategori + (süper ise) zorluk seviyesi tek seferde kaydedilir
    const saveSection1 = async () => {
      if (!question.value?.data?.id || !selectedBranchId.value) return;
      try {
        isLoading.value = true;
        const subId =
          selectedSubCategoryId.value != null &&
          selectedSubCategoryId.value !== undefined
            ? selectedSubCategoryId.value
            : 0;
        await updateQuestionCategory(selectedBranchId.value, subId);
        if (selectedDifficultyLevel.value != null) {
          await store.dispatch("postDatas", {
            api: "questions/setdifficulty",
            data: {
              id: question.value.data.id,
              difficultyLevelId: selectedDifficultyLevel.value
            }
          });
        }
        question.value = await getQuestion();
        if (store.state.usertype === 2 && question.value?.data?.categoryId) {
          questionCount.value = await getQuestionCount();
        }
      } finally {
        isLoading.value = false;
      }
    };
    const updateQuestionCategory = async (categoryId, subCategoryId) => {
      if (!question.value || !question.value.data || !question.value.data.id) {
        return;
      }
      try {
        isLoading.value = true;
        // Mevcut soru verilerini al
        // subCategoryId null veya undefined ise 0 yap
        const finalSubCategoryId =
          subCategoryId !== null && subCategoryId !== undefined
            ? subCategoryId
            : 0;
        const questionData = {
          Id: question.value.data.id,
          CategoryId: categoryId || question.value.data.categoryId,
          SubCategoryId: finalSubCategoryId,
          CategoryName: question.value.data.categoryName || "",
          Username: store.state.username || "",
          Number: question.value.data.number,
          UserId: question.value.data.userId,
          ExamNumber: question.value.data.examNumber,
          Month: question.value.data.month,
          Year: question.value.data.year,
          IsCase: question.value.data.isCase,
          Case: question.value.data.case,
          Detail: question.value.data.detail,
          DetailModifield: question.value.data.detailModifield,
          ChoiceList: question.value.data.choiceList || [],
          Answer: question.value.data.answer,
          Description: question.value.data.description,
          // Özgün soru alanlarını koru (Bölüm 1 kaydında ezilmesin)
          TeacherId: question.value.data.teacherId ?? null,
          MyOriginalCase: question.value.data.myOriginalCase || "",
          MyOriginalDetail: question.value.data.myOriginalDetail || "",
          MyOriginalA: question.value.data.myOriginalA || "",
          MyOriginalB: question.value.data.myOriginalB || "",
          MyOriginalC: question.value.data.myOriginalC || "",
          MyOriginalD: question.value.data.myOriginalD || "",
          MyOriginalE: question.value.data.myOriginalE || "",
          MyOriginalAnswer:
            question.value.data.myOriginalAnswer &&
            String(question.value.data.myOriginalAnswer).trim() !== ""
              ? question.value.data.myOriginalAnswer
              : null
        };
        await store.dispatch("postDatas", {
          api: "questions/addquestion",
          data: questionData
        });
        // Soruyu yeniden yükle
        question.value = await getQuestion();
        // Select değerlerini güncelle
        if (categoryId) {
          selectedBranchId.value = categoryId;
        }
        // subCategoryId 0 ise null yap, değilse değeri kullan
        if (finalSubCategoryId && finalSubCategoryId !== 0) {
          selectedSubCategoryId.value = finalSubCategoryId;
        } else {
          selectedSubCategoryId.value = null;
        }
      } catch (error) {
        console.error("Soru güncellenirken hata:", error);
      } finally {
        isLoading.value = false;
      }
    };

    const AddReference = () => {
      sdersnot.value = null;
      imgData.value.subcatname = questionType.value;
      imgData.value.noteid = sdersnot.value;
      imgData.value.catname = question.value.data.categoryName;
      imgData.value.catid = question.value.data.categoryId;
      imgData.value.examnumber = question.value.data.examNumber;
      imgData.value.userid = store.state.userid;
      saveData.value.userId = store.state.userid;
      saveData.value.id = 0;
      selectedFassicule.value = null;
      selectedPage.value = null;
      imgData.value.detail = [];
      imgUrl.value = "";
      imgPanel.value = true;
    };

    const openVideoReferenceModal = () => {
      if (!question.value || !question.value.data || !question.value.data.id) {
        console.warn("[VIDEO_REFERENCE] Question ID yok, modal açılamıyor");
        return;
      }
      selectedVideoReference.value = null;
      showVideoModal.value = true;
    };

    const videoReferenceListRef = ref(null);

    const handleVideoReferenceSaved = () => {
      showVideoModal.value = false;
      selectedVideoReference.value = null;
      // VideoReferenceList component'ini yenile - gecikme ile güvenli hale getir
      setTimeout(() => {
        if (
          videoReferenceListRef.value &&
          typeof videoReferenceListRef.value.getVideoReferences === "function"
        ) {
          videoReferenceListRef.value.getVideoReferences();
        }
      }, 100);
    };
    const editFunc = async d => {
      sdersnot.value = d.row.lessonNoteId;
      saveData.value.id = d.row.id;
      saveData.value.lessonNoteId = d.row.lessonNoteId;
      saveData.value.noteCategoryId = d.row.noteCategoryId;
      let note = notesList.value.data.filter(v => {
        return v.id === d.row.lessonNoteId;
      })[0];
      createFasikuls(note);
      selectedFassicule.value = d.row.pages[0].fassiculeId;
      imgData.value.fassiculeId = d.row.pages[0].fassiculeId;
      selectedPage.value = d.row.pages[0].pageNo;
      imgData.value.notename = note.name;
      imgData.value.imgcatid = note.categoryId;
      imgData.value.pageNo = d.row.pages[0].pageNo;
      imgData.value.subcatname = questionType.value;
      imgData.value.noteid = sdersnot.value;
      imgData.value.catname = question.value.data.categoryName;
      imgData.value.catid = question.value.data.categoryId;
      imgData.value.examnumber = question.value.data.examNumber;
      imgData.value.detail = d.row.pages[0].detail;
      imgData.value.userid = d.row.userId;
      imgData.value.refid = d.row.pages[0].referenceId;
      saveData.value.userId = d.row.userId;
      let imgurl = getReferenceImageProxyUrl({
        workFolder: currentWorkFolder.value,
        imageRoot: `ref_img_${store.state.usertype}`,
        categoryId: imgData.value.imgcatid,
        noteId: sdersnot.value,
        fileName: `${d.row.pages[0].pageNo.toString().padStart(3, "0")}.jpg`
      });
      imgUrl.value = imgurl;
      imgPanel.value = true;
    };
    const dersNoteChange = d => {
      imgData.value.notename = d.name;
      imgData.value.imgcatid = d.categoryId;
      saveData.value.lessonNoteId = d.id;
      saveData.value.noteCategoryId = d.categoryTypeId;
      selectedFassicule.value = null;
      selectedPage.value = null;
      fasikulCount.value = [];
      saveData.value.pages = [{}];
      setTimeout(() => {
        createFasikuls(d);
      }, 100);
    };
    const createFasikuls = d => {
      fasikulCount.value = [];
      var pages = d.pageNo.split("#");
      for (let i = 0; i < d.fassiculeCount; i++) {
        fasikulCount.value.push(i + 1);
        let p = pages[i].split("-");
        fasikulPages.value["p" + (i + 1)] = [];
        for (let j = parseInt(p[0]); j <= parseInt(p[1]); j++) {
          fasikulPages.value["p" + (i + 1)].push({ f: i + 1, p: j });
        }
      }
    };
    const fassiculeChange = d => {
      saveData.value.pages[0].fassiculeId = d;
      selectedPage.value = null;
    };
    const pageSelected = d => {
      imgUrl.value = "";
      imgData.value.fassiculeId = d.f;
      saveData.value.pages[0].pageNo = d.p;
      imgData.value.pageNo = d.p;
      imgData.value.subcatname = questionType.value;
      imgData.value.noteid = sdersnot.value;
      imgData.value.catname = question.value.data.categoryName;
      imgData.value.catid = question.value.data.categoryId;
      imgData.value.examnumber = question.value.data.examNumber;
      imgData.value.detail = [];
      let imgurl = getReferenceImageProxyUrl({
        workFolder: currentWorkFolder.value,
        imageRoot: `ref_img_${store.state.usertype}`,
        categoryId: imgData.value.imgcatid,
        noteId: sdersnot.value,
        fileName: `${d.p.toString().padStart(3, "0")}.jpg`
      });
      imgUrl.value = imgurl;
    };
    const previewPage = () => {
      selectedPage.value = selectedPage.value - 1;
      imgUrl.value = "";
      imgData.value.fassiculeId = saveData.value.pages[0].fassiculeId;
      saveData.value.pages[0].pageNo = selectedPage.value;
      imgData.value.pageNo = selectedPage.value;
      imgData.value.subcatname = questionType.value;
      imgData.value.noteid = sdersnot.value;
      imgData.value.catname = question.value.data.categoryName;
      imgData.value.catid = question.value.data.categoryId;
      imgData.value.examnumber = question.value.data.examNumber;
      imgData.value.detail = [];
      let imgurl = getReferenceImageProxyUrl({
        workFolder: currentWorkFolder.value,
        imageRoot: `ref_img_${store.state.usertype}`,
        categoryId: imgData.value.imgcatid,
        noteId: sdersnot.value,
        fileName: `${selectedPage.value.toString().padStart(3, "0")}.jpg`
      });
      imgUrl.value = imgurl;
    };
    const lastPage = () => {
      selectedPage.value = selectedPage.value + 1;
      imgUrl.value = "";
      imgData.value.fassiculeId = saveData.value.pages[0].fassiculeId;
      saveData.value.pages[0].pageNo = selectedPage.value;
      imgData.value.pageNo = selectedPage.value;
      imgData.value.subcatname = questionType.value;
      imgData.value.noteid = sdersnot.value;
      imgData.value.catname = question.value.data.categoryName;
      imgData.value.catid = question.value.data.categoryId;
      imgData.value.examnumber = question.value.data.examNumber;
      imgData.value.detail = [];
      let imgurl = getReferenceImageProxyUrl({
        workFolder: currentWorkFolder.value,
        imageRoot: `ref_img_${store.state.usertype}`,
        categoryId: imgData.value.imgcatid,
        noteId: sdersnot.value,
        fileName: `${selectedPage.value.toString().padStart(3, "0")}.jpg`
      });
      imgUrl.value = imgurl;
    };
    const saveNote = async (d, t) => {
      dataList.value[d.iid].data1[d.tid].data[d.pid].pages[0].detail[
        d.kid
      ].note = t;
      dataList.value[d.iid].data1[d.tid].data[d.pid].pages[0].detail[d.kid] = d;
      await savePage(dataList.value[d.iid].data1[d.tid].data[d.pid]);
    };
    const selectImage = (i, j, k, l) => {
      if (imageSelectData.value.i !== undefined) {
        dataList.value[imageSelectData.value.i].data1[
          imageSelectData.value.j
        ].data[imageSelectData.value.k].pages[0].detail[
          imageSelectData.value.l
        ].selected = false;
      }
      dataList.value[i].data1[j].data[k].pages[0].detail[l].selected = true;
      imageSelectData.value = { i: i, j: j, k: k, l: l };
    };
    const savePage = async d => {
      var data = {};
      if (d) data = Object.assign({}, d);
      else data = Object.assign({}, saveData.value);

      // Backend zorunlu alanları doldur (400 hatası önleme)
      data.username = data.username || store.state.username || "";
      data.updatedBy = data.updatedBy || store.state.username || "";
      data.referenceNote = data.referenceNote ?? "";
      data.lessonNoteName =
        data.lessonNoteName ||
        notesList.value?.data?.find(n => n.id === data.lessonNoteId)?.name ||
        imgData.value?.notename ||
        "";
      data.noteCategoryName =
        data.noteCategoryName ||
        notesCatsList.value?.data?.find(c => c.id === data.noteCategoryId)
          ?.title ||
        "";
      // NoteBranchName zorunlu - ders notunun branş adı (branchName ile aynı olabilir)
      data.noteBranchName =
        data.noteBranchName ||
        data.branchName ||
        imgData.value?.catname ||
        "";
      data.questionAnswer =
        data.questionAnswer ?? question.value?.data?.answer ?? "";
      data.questionDetail =
        data.questionDetail ??
        (question.value?.data?.isCase
          ? (question.value?.data?.case || "") +
            (question.value?.data?.detail || "")
          : question.value?.data?.detail) ??
        "";
      data.questionChoices =
        data.questionChoices ?? question.value?.data?.choiceList ?? [];

      data.pages.forEach(itm => {
        delete itm.id;
        // url ve originalUrl zorunlu - yoksa oluştur
        const fileName = itm.fileName || imgData.value?.fileName;
        const noteId = data.lessonNoteId ?? imgData.value?.noteid;
        const catId = imgData.value?.imgcatid ?? imgData.value?.catid;
        if (!itm.url && fileName && noteId && catId) {
          const base = getReferenceImageProxyUrl({
            workFolder: currentWorkFolder.value,
            imageRoot: `edited_ref_img_${store.state.usertype}`,
            categoryId: catId,
            noteId: noteId,
            fileName: `${fileName}.jpg`
          });
          itm.url = base;
          itm.originalUrl = itm.originalUrl || base;
        }
        itm.url = itm.url || "";
        itm.originalUrl = itm.originalUrl || itm.url || "";
        itm.detail?.forEach(sub => {
          delete sub.id;
          delete sub.iid;
          delete sub.tid;
          delete sub.pid;
        });
      });

      delete data.pid;
      delete data.hasPermission;
      
      console.log("[savePage] Gönderilen data:", JSON.stringify(data, null, 2));
      
      await store.dispatch("postDatas", {
        api: "references/addreference",
        data: data
      });
      imageSelectData.value = {};
      let list = await getReferenceDetail();
      refDatas.value = Object.assign({}, list);
      newList();
    };
    const createPDF = () => {
      if (isCreating.value) return;
      isCreating.value = true;
      setTimeout(() => {
        const doc = new jsPDF("p", "px", [1000, 1415]);

        var els = document.getElementsByClassName("pdf-screen-W-save");
        var cnt = 0;
        var imgCnt = 0;
        var imgC = {};
        var intC = {};
        els.forEach(async (el, i) => {
          await html2canvas(el, {
            scale: 2.535,
            scrollX: 0,
            scrollY: 0,
            width: 700
          }).then(function(canvas) {
            imgC["im" + i] = canvas.toDataURL("image/jpeg");
            intC["i" + i] = setInterval(() => {
              if (imgC["im" + i] !== "") {
                clearInterval(intC["i" + i]);
                cnt++;
              }
            }, 300);
          });
        });
        var saveImgInt = setInterval(() => {
          if (cnt === els.length) {
            clearInterval(saveImgInt);
            for (let e = 0; e < els.length; e++) {
              doc.addImage(imgC["im" + e], "JPEG", 0, 0);
              imgCnt++;
              if (imgCnt !== els.length) doc.addPage();
              delete imgC["im" + e];
            }
          }
        }, 1000);
        var int = setInterval(() => {
          if (imgCnt === els.length) {
            clearInterval(int);
            doc.save(
              currentWorkFolder.value +
                "_" +
                question.value.data.examNumber +
                ".pdf"
            );
            isCreating.value = false;
          }
        }, 600);
      }, 50);
    };
    watch(
      () => saveme.value,
      () => {
        if (saveme.value) {
          console.log("[saveme watch] Triggered, imgData:", JSON.stringify(imgData.value, null, 2));
          console.log("[saveme watch] question:", JSON.stringify(question.value?.data, null, 2));
          console.log("[saveme watch] saveData BEFORE:", JSON.stringify(saveData.value, null, 2));
          
          try {
            // pages array'i yoksa oluştur
            if (!saveData.value.pages) saveData.value.pages = [];
            if (!saveData.value.pages[0]) saveData.value.pages.push({});
            
            // Zorunlu alanları imgData ve question'dan doldur
            saveData.value.branchId = saveData.value.branchId || imgData.value?.catid || question.value?.data?.categoryId || 0;
            saveData.value.branchName = saveData.value.branchName || imgData.value?.catname || "";
            saveData.value.questionId = saveData.value.questionId || question.value?.data?.id || 0;
            saveData.value.questionExamNumber = saveData.value.questionExamNumber || question.value?.data?.examNumber || 0;
            saveData.value.lessonNoteId = saveData.value.lessonNoteId || imgData.value?.noteid || 0;
            saveData.value.noteCategoryId = saveData.value.noteCategoryId || imgData.value?.imgcatid || imgData.value?.catid || 0;
            
            saveData.value.pages[0].fileName = imgData.value.fileName;
            saveData.value.pages[0].detail = imgData.value.detail;
            saveData.value.pages[0].fassiculeId = imgData.value.fassiculeId;
            saveData.value.pages[0].referenceId = imgData.value.refid;
            saveData.value.pages[0].pageNo = imgData.value.pageNo;
            
            console.log("[saveme watch] saveData AFTER:", JSON.stringify(saveData.value, null, 2));
            savePage();
          } catch (err) {
            console.error("[saveme watch] Error:", err);
          }
          saveme.value = false;
        }
      }
    );
    watch(
      () => store.state.scrollY,
      () => {
        canFixed.value = store.state.scrollY >= 180 ? true : false;
      }
    );
    watch(
      () => imgPanel.value,
      async () => {
        if (imgPanel.value === false) {
          let data = await getReferenceDetail();
          refDatas.value = Object.assign({}, data);
          newList();
        }
      }
    );
    watch(
      () => pageUpdated.value,
      () => {
        if (pageUpdated.value) {
          var el = document.querySelector(".references-list-C");
          setTimeout(() => {
            window.scrollTo(0, pageScrollTop.value);
          }, 200);
          setTimeout(() => {
            el.scrollTo(0, listScrollTop.value);
            isLoading.value = false;
          }, 350);
        }
      }
    );
    const getDifficultyLevels = async () => {
      try {
        let list = await store.dispatch("getDatas", {
          api: "questions/getalldifficultylevels"
        });
        if (list && list.data) {
          difficultyLevels.value = Array.isArray(list.data) ? list.data : [];
        }
      } catch (error) {
        console.error("Error fetching difficulty levels:", error);
        difficultyLevels.value = [];
      }
    };

    const onDifficultyLevelChange = async e => {
      // Event formatı: e.val veya e.id gelebilir
      const difficultyLevelId =
        e?.val !== undefined ? e.val : e?.id !== undefined ? e.id : null;
      selectedDifficultyLevel.value =
        difficultyLevelId != null ? Number(difficultyLevelId) : null;

      // Zorluk değişince Bölüm 1'i otomatik kaydet
      if (selectedBranchId.value) {
        await saveSection1();
      }
    };

    onMounted(async () => {
      question.value = await getQuestion();
      notesList.value = await getNotesList();
      notesCatsList.value = await getNoteCatsList();
      refDatas.value = await getReferenceDetail();

      if (question.value?.data?.categoryId) {
        questionCount.value = await getQuestionCount();
      } else {
        questionCount.value = 0;
      }

      // Zorluk seviyelerini getir
      await getDifficultyLevels();

      // Mevcut zorluk seviyesini select'e bind et
      if (
        question.value &&
        question.value.data &&
        question.value.data.difficultyLevelId
      ) {
        selectedDifficultyLevel.value =
          question.value.data.difficultyLevelId != null
            ? Number(question.value.data.difficultyLevelId)
            : null;
      }

      // Branş ve alt kategori listelerini yükle
      const branchResult = await getCatList(0);
      if (
        branchResult &&
        branchResult.data &&
        Array.isArray(branchResult.data)
      ) {
        // Soru çeşidine göre filtrele (CategoryId'den parentId'yi bul)
        const currentCategoryId = question.value.data.categoryId;
        // Mevcut CategoryId'ye göre branş listesini filtrele
        const filteredBranches = branchResult.data.filter(item => {
          // Eğer soru zaten bir CategoryId'ye sahipse, o kategoriyi ve parent'ını göster
          if (item.id === currentCategoryId) return true;
          // Tüm branşları göster, kullanıcı seçsin
          return true;
        });
        branchList.value = { data: filteredBranches };

        // Mevcut CategoryId'yi seç
        if (currentCategoryId) {
          selectedBranchId.value =
            currentCategoryId != null ? Number(currentCategoryId) : null;
          // Alt kategorileri getir
          const subCatResult = await store.dispatch("getDatas", {
            api: "categories/getsubcategories",
            params: { pid: currentCategoryId }
          });
          if (
            subCatResult &&
            subCatResult.data &&
            Array.isArray(subCatResult.data)
          ) {
            subCategoryList.value = { data: subCatResult.data };
            // Mevcut SubCategoryId'yi seç (0 ise null yap)
            if (
              question.value.data.subCategoryId &&
              question.value.data.subCategoryId !== 0
            ) {
              selectedSubCategoryId.value =
                question.value.data.subCategoryId != null
                  ? Number(question.value.data.subCategoryId)
                  : null;
            } else {
              selectedSubCategoryId.value = null;
            }
          }
        }
      }

      if (refDatas.value.data.length > 0) {
        isLoading.value = true;
        newList();
      }
      saveData.value.userId = store.state.userid;
      saveData.value.branchId = parseInt(question.value.data.categoryId);
      saveData.value.questionId = parseInt(route.params.id);
      saveData.value.pages = [];
      loaded.value = true;
    });
    return {
      notesList,
      distinctNotes,
      selectedFassicule,
      sdersnot,
      dersNoteChange,
      fasikulCount,
      fasikulPages,
      selectedPage,
      imgPanel,
      imgData,
      imgUrl,
      currentWorkFolder,
      question,
      loaded,
      pageSelected,
      saveData,
      store,
      AddReference,
      openVideoReferenceModal,
      handleVideoReferenceSaved,
      showVideoModal,
      selectedVideoReference,
      videoReferenceListRef,
      fassiculeChange,
      previewPage,
      lastPage,
      headdata,
      refDatas,
      teacherdata,
      drawdata,
      saveme,
      outeropt,
      teacherOpt,
      teacherListOpt,
      drawOpt,
      canFixed,
      dataList,
      imagesList,
      newDataList,
      questionType,
      saveNote,
      selectImage,
      createPDF,
      goQuestion,
      maxQuest,
      router,
      listloaded,
      pagesloaded,
      imgListData,
      isLoading,
      pageUpdated,
      isCreating,
      difficultyLevels,
      difficultyOptions,
      selectedDifficultyLevel,
      onDifficultyLevelChange,
      branchList,
      selectedBranchId,
      branchOptions,
      subCategoryList,
      selectedSubCategoryId,
      subCategoryOptions,
      onBranchChange,
      onSubCategoryChange,
      isSection2Allowed,
      saveSection1,
      // Özgün soru modalı
      showOriginalModal,
      openOriginalQuestionModal,
      saveOriginalQuestion,
      originalData,
      originalTeacherOptions,
      originalAnswerOptions,
      isSavingOriginal,
      isTeacher,
      // Soru kökü modalı
      showSoruKokuModal,
      openSoruKokuModal,
      saveSoruKoku,
      detailModifieldEdit,
      isSavingSoruKoku,
      choiceListForDisplay,
      originalChoiceListForDisplay,
      originalChoicesFiltered,
      hasAnyOriginalContent,
      choiceLabels
    };
  }
};
</script>
<style scoped>
.cat-warning-C {
  background-color: crimson;
  color: #fff;
  border-radius: 3px;
  padding: 8px 16px;
  margin-bottom: 16px;
}
.difficulty-select-C {
  margin-right: 0;
}
.page-header-C {
  width: 100%;
}
.page-header-C > .r-flx {
  flex: 1;
  min-width: 0;
}
.dynamic-property-C {
  margin-right: 12px;
}
.dynamic-property-C label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  display: block;
}
.dynamic-properties-wrapper-C {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  margin-top: 16px;
  width: 100%;
  flex-shrink: 0;
}
.video-references-wrapper-C {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  margin-top: 16px;
  width: 100%;
  flex-shrink: 0;
}
.organic-question-wrapper-C,
.soru-koku-wrapper-C {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  margin-top: 16px;
  width: 100%;
  flex-shrink: 0;
}
.section-title-C {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #333;
}
.readonly-content-C {
  font-size: 13px;
  color: #444;
}
.readonly-block {
  margin-bottom: 12px;
}
.readonly-block strong {
  display: block;
  margin-bottom: 4px;
  color: #222;
}
.readonly-html {
  max-height: 200px;
  overflow-y: auto;
  padding: 6px 0;
  line-height: 1.4;
}
.readonly-html.inline {
  max-height: none;
  display: inline;
}
.readonly-choice {
  margin-bottom: 6px;
}
.readonly-choice .choice-letter {
  font-weight: 600;
  margin-right: 6px;
  min-width: 18px;
  display: inline-block;
}
.readonly-empty {
  color: #888;
  font-style: italic;
  padding: 8px 0;
}

/* 2x2 aksiyon butonları: tam 2 satır x 2 sütun */
.action-buttons-2x2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 8px;
  margin-bottom: 12px;
  min-height: 100px;
  width: 100%;
}
.action-btn-cell {
  min-width: 0;
  min-height: 44px;
  display: flex;
}
.action-btn-cell > * {
  flex: 1;
  min-width: 0;
  width: 100%;
}

/* Dar pencerede iki kolon taşmasın; yatay scroll ile korunur */
.referans-edit-main {
  min-width: 1200px !important;
}

/* Hoca için disabled teacher display field */
.teacher-display-field {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 6px;
}
.teacher-display-label {
  font-size: 12px;
  color: rgb(0, 56, 160);
  margin-bottom: 4px;
}
.teacher-display-value {
  padding: 8px 10px;
  border: 1px solid #e0d9d9;
  border-radius: 6px;
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}
</style>
